import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '../types';

interface UsersState {
  users: User[];
  replaceAll: (users: User[]) => void;
  add: (user: User) => void;
  update: (id: string, patch: Partial<User>) => void;
  remove: (id: string) => void;
  getById: (id: string) => User | undefined;
}

export const useUsersStore = create<UsersState>()(
  persist(
    (set, get) => ({
      users: [],
      replaceAll: users => set({ users }),
      add: user => set(state => ({ users: [...state.users, user] })),
      update: (id, patch) => set(state => ({
        users: state.users.map(user => user.id === id ? { ...user, ...patch } : user),
      })),
      remove: id => set(state => ({ users: state.users.filter(user => user.id !== id) })),
      getById: id => get().users.find(user => user.id === id),
    }),
    { name: 'masar-users' },
  ),
);
